import axiosClient from "./axios-client";

export const login = async (email, password) => {
  const response = await axiosClient.post("/auth/login", {
    email,
    password,
  });

  return response.data;
};

export const logout = async () => {
  await axiosClient.post("/auth/logout");

  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");

  window.location.href = "/sign-in";
};

export const getCurrentUser = async () => {
  const response = await axiosClient.get("/auth/me");
  return response.data;
};